import styled, { css } from 'styled-components';

import { Button } from 'components/core';
import { AnchorButton as _AnchorButton } from 'components/core/button';

/**
 * Shared styled components for instore-enrollment steps
 * These components provide consistent layout and styling across all enrollment steps
 */

export const StepPanel = styled.main`
  ${({ theme: { spaces } }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0; /* Allow flex child to shrink */
    padding: 0 ${spaces[6]} ${spaces[6]};
  `}
`;

export const StepFooter = styled.footer`
  ${({ theme: { spaces } }) => css`
    padding: ${spaces[6]};
    text-align: center;
    width: 100%;
  `}
`;

export const CenteredColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  text-align: center;
  gap: ${({ theme }) => theme.spaces[4]};
`;

export const StepButton = styled(Button).attrs({ variant: 'primary', fluid: true })`
  height: 52px;
  margin-bottom: ${({ theme }) => theme.spaces[4]};
`;

export const AnchorButton = styled(_AnchorButton).attrs({ variant: 'primary', fluid: true })`
  height: 52px;
  margin-bottom: ${({ theme }) => theme.spaces[4]};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 14px;
`;

export const SkipButton = styled(Button).attrs({ variant: 'outlinePrimary', fluid: true })`
  height: 52px;
  margin-bottom: ${({ theme }) => theme.spaces[4]};
`;
